import gql from 'graphql-tag'

export const getAccountCertificate = gql`
  query($accountCertificateId: Int!) {
    getAccountCertificate(
      accountCertificateId: $accountCertificateId
    ) {
      id
      name
      notes
      type
      accountId
      ssn
      firstName
      middleName
      lastName
      licenseNumber
      expirationDate
      idNumber
      createdAt
      updatedAt
      account {
        id
        name
      }
      createdBy {
        id
        username
      }
      lastModifiedBy {
        id
        username
      }
      files {
        id
        type
        name
        size
        createdAt
        updatedAt
      }
    }
  }
`

export const newAccountCertificate = gql`
  mutation($input: AccountCertificateInput!, $accountId: Int!) {
    newAccountCertificate(
      accountId: $accountId,
      accountCertificateInput: $input
    ) {
      id
    }
  }
`

export const editAccountCertificate = gql`
  mutation($accountCertificateId: Int!, $input: AccountCertificateInput!) {
    editAccountCertificate(
      accountCertificateId: $accountCertificateId,
      accountCertificateInput: $input
    ) {
      id
    }
  }
`

export const deleteAccountCertificate = gql`
  mutation($accountCertificateId: Int!) {
    deleteAccountCertificate(
      accountCertificateId: $accountCertificateId
    )
  }
`
